var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isAdminRole
    ? _c("div", [
        _c("div", { staticClass: "fab-title" }, [
          _vm._v(_vm._s(_vm.$t("FAB_TITLES." + _vm.getFabLink.title)))
        ]),
        _vm._v(" "),
        _vm.getFabLink
          ? _c(
              "div",
              [
                _vm.getFabLink.type === "url"
                  ? _c("router-link", { attrs: { to: _vm.getFabLink.url } }, [
                      _c("div", {
                        staticClass: "fab-circle bg-secondary",
                        domProps: { innerHTML: _vm._s(_vm.getFabLink.icon) }
                      })
                    ])
                  : _c(
                      "div",
                      [
                        _c("b-button", {
                          staticClass: "fab-circle bg-secondary",
                          domProps: { innerHTML: _vm._s(_vm.getFabLink.icon) },
                          on: {
                            click: function($event) {
                              _vm.download(_vm.routeName)
                            }
                          }
                        })
                      ],
                      1
                    )
              ],
              1
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-853854f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-853854f2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fab.vue
// module id = 955
// module chunks = 2